<template>
    <div class="bdata" v-loading.fullscreen.lock="loading">
        <el-button type="primary" @click="goSupport" size="small">切换</el-button>
        <div v-if="type">
            <div class="top">
                <el-form :model="model">
                    <el-table size="mini"
                              :data="list"
                              border
                              element-loading-text="加载中"
                              style="width: 100%">
                        <el-table-column type="index" label="序号" width="50">
                        </el-table-column>
                        <el-table-column label="id"
                                         prop="id"
                                         :show-overflow-tooltip="true"
                                         width="50">
                        </el-table-column>
                        <el-table-column label="name" prop="name"></el-table-column>
                        <el-table-column label="表达式">
                            <template #default="scope">
                                <span class="ellipsis">
                                    {{ scope.row.expr }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="type" prop="type"> </el-table-column>
                        <el-table-column label="tag" prop="tag" :filters="tagType.map((e, idx)=>{return { text: e, value: e };})" :filter-method="filterTag"></el-table-column>
                        <el-table-column label="操作" width="100">
                            <template #default="scope">
                                <el-button v-if="!scope.row.editType"
                                           @click="add(scope.row)"
                                           type="primary"
                                           size="mini">添加</el-button>
                                <el-button v-else
                                           type="info"
                                           size="mini"
                                           @click="revoke(scope.row)">已选</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </el-form>
            </div>
        </div>
        <div v-else>
            <el-form :model="model">
                <div style="margin: 10px">
                    <el-autocomplete v-model="divname"
                                     size="mini"
                                     class="inline-input"
                                     :fetch-suggestions="querySearchDivid"
                                     placeholder="请输入内容"
                                     @select="handleSelectDivid"
                                     value-key="name"
                                     clearable
                                     @change="cleanExprList"></el-autocomplete>
                </div>
                <div class="top">
                    <el-table size="mini"
                              :data="list"
                              border
                              style="width: 100%">
                        <el-table-column type="index" label="序号" width="50">
                        </el-table-column>
                        <el-table-column label="id"
                                         prop="id"
                                         :show-overflow-tooltip="true"
                                         width="50">
                        </el-table-column>
                        <el-table-column label="name" prop="name">
                            <template #default="scope">
                                <el-form-item>
                                    <el-input v-if="inputShow == scope.row.id && nameType"
                                              v-model="model.editList[scope.$index].name"
                                              size="small"></el-input>
                                    <span class="ellipsis" v-else>
                                        {{ model.editList[scope.$index].name }}
                                    </span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="表达式">
                            <template #default="scope">
                                <span class="ellipsis"
                                      style="color: #66c2ff; cursor: pointer"
                                      v-if="inputShow == scope.row.id"
                                      @click="doExpr(scope.row, scope.$index)">{{ model.editList[scope.$index].expr }}</span>
                                <span class="ellipsis" v-else>
                                    {{ model.editList[scope.$index].expr }}
                                </span>
                            </template>
                        </el-table-column>
                        <el-table-column label="type" prop="type">
                            <template #default="scope">
                                <el-form-item>
                                    <el-input v-if="inputShow == scope.row.id"
                                              v-model="model.editList[scope.$index].type"
                                              size="small"></el-input>
                                    <span v-else>{{ model.editList[scope.$index].type }}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="tag">
                            <template #default="scope">
                                <el-form-item>
                                    <!-- <div v-if="inputShow == scope.row.id">
                                        <el-tag v-if="!inputVisible"
                                                :disable-transitions="false"
                                                @click="showInput">
                                            {{tag}}
                                        </el-tag>
                                        <el-input class="input-new-tag"
                                                  v-if="inputVisible"
                                                  v-model="model.editList[scope.$index].tag"
                                                  ref="saveTagInput"
                                                  size="small"
                                                  @keyup.enter="handleInputConfirm(model.editList[scope.$index].tag)"
                                                  @blur="handleInputConfirm(model.editList[scope.$index].tag)"></el-input>
                                    </div> -->
                                    <el-input class="input-new-tag"
                                              v-if="inputShow == scope.row.id"
                                              v-model="model.editList[scope.$index].tag"
                                              ref="saveTagInput"
                                              size="small"
                                              @keyup.enter="handleInputConfirm(model.editList[scope.$index].tag)"
                                              @blur="handleInputConfirm(model.editList[scope.$index].tag)"></el-input>
                                    <span v-else>{{ model.editList[scope.$index].tag }}</span>
                                </el-form-item>
                            </template>
                        </el-table-column>
                        <el-table-column label="预览">
                            <template #default="scope" v-if="exprType">
                                <div v-for="(item, index) in exprList" :key="index">
                                    <span class="ellipsis"
                                          style="cursor: pointer"
                                          :class="{ error: !item.type }"
                                          v-if="scope.row.id == item.id"
                                          @click="previewShow(item)">{{ item.expr }}</span>
                                </div>
                            </template>
                        </el-table-column>
                        <el-table-column label="操作" width="230">
                            <template #default="scope">
                                <el-button @click="change(scope.row)"
                                           v-if="inputShow !== scope.row.id"
                                           type="primary"
                                           size="mini">修改</el-button>
                                <el-button @click="save(scope.row.id)"
                                           v-else
                                           type="primary"
                                           size="mini">保存</el-button>

                                <el-popconfirm title="确定删除吗？"
                                               confirmButtonText="确定"
                                               cancelButtonText="取消"
                                               @confirm="del(scope.row.id)">
                                    <template #reference>
                                        <el-button type="danger" size="mini">删除</el-button>
                                    </template>
                                </el-popconfirm>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </el-form>
            <el-button icon="el-icon-plus"
                       @click="append"
                       class="marginBottom"
                       size="small"
                       :disabled="newlyAddType">添加</el-button>
        </div>
        <div v-show="containerShow" class="mask">
            <div class="mask-c">
                <div ref="container" class="container"></div>
                <div class="footer">
                    <el-button type="primary" @click="saveExpr">保存</el-button>
                    <el-button @click="exprBack">返回</el-button>
                </div>
            </div>
        </div>
        <el-dialog title="预览" v-model="dialogVisible">
            <json-viewer :value="previewDetail"
                         :expand-depth="5"
                         copyable
                         boxed></json-viewer>
        </el-dialog>
    </div>
</template>

<script>
    import { bdataEdit, bdataDelete, bdata } from "@/api/bdata.js";
    import { postBdata, getBdata } from "@/api/zone.js";
    import { getDivs, div } from '@/api/div.js'
    import * as monaco from "monaco-editor";
    export default {
        name: "bdata",
        data() {
            return {
                loading: false,
                list: [], //表格主体
                model: {
                    editList: [], //编辑状态下表格主体
                },
                exprList: [], //预览列表
                exprType: false,
                previewDetail: "", //预览内容
                previewType: false, //浏览状态
                bdataValue: [],
                bdataList: [],
                type: false,
                //   另一个页面
                divs: [],
                divname: "",
                containerShow: false,
                exprId: "",
                nameType: false, //新增时可以修改名字
                inputShow: false, //修改状态
                newlyAddType: false,
                dialogVisible: false, //浏览状态
                tagType: [],
                tag: '',
                inputVisible: false,
            };
        },
        mounted() {
            this.initEditor();
        },
        created() {
            this.init();
            this.getDivsList();
        },
        methods: {
            showInput() {
                this.inputVisible = true;
                this.$nextTick(_ => {
                    this.$refs.saveTagInput.$refs.input.focus();
                });
            },
            handleInputConfirm(tag) {
                this.tag = tag
                this.inputVisible = false;
            },
            filterTag(value, row) {
                return row.tag === value;
            },
            // 添加
            append() {
                this.inputShow = "";
                this.tag = '点击输入'
                this.nameType = true;
                this.newlyAddType = true;
                this.model.editList.push({
                    id: "",
                    name: "",
                    expr: "点击输入",
                    type: "number",
                });
                this.list.push({
                    id: "",
                    name: "",
                    expr: "点击输入",
                    type: "number",
                    detail: "",
                });
                this.exprList.push("");
            },
            // 表达式循环
            exprEach(expr, id) {
                let detail = this.preview(expr);
                this.exprList.forEach((item) => {
                    if (item.id == id) {
                        item.expr = detail.result;
                        item.type = detail.type;
                    }
                });
            },
            // 表达式编辑器关闭
            exprBack() {
                this.containerShow = false;
                this.editor.setValue("");
            },
            // 保存表达式
            saveExpr() {
                //编辑器的内容
                let ac = this.editor.getValue();
                let detail = this.preview(ac);
                this.model.editList.forEach((ele) => {
                    if (ele.id == this.exprId) {
                        ele.expr = ac;
                    }
                });
                if (detail !== null) {
                    if (this.exprId.length !== 0) {
                        this.exprEach(ac, this.exprId);
                    } else {
                        //添加的预览功能
                        if (this.exprList.find((e) => e.id == "") == undefined) {
                            this.exprList[this.exprList.length - 1] = {
                                id: "",
                                expr: detail.result,
                                type: detail.type,
                            };
                        } else {
                            this.exprEach(ac, this.exprId);
                        }
                    }
                }
                this.containerShow = false;
            },
            // 删除功能
            del(id) {
                if (id == "") {
                    this.init();
                    this.inputShow = false;
                    this.newlyAddType = false;
                    return;
                }
                this.loading = true;
                bdataDelete({
                    id: id,
                })
                    .then((res) => {
                        if (res.status == 0) {
                            this.$message.success("已删除");
                            this.init();
                        }
                        this.loading = false;
                        this.newlyAddType = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                        this.newlyAddType = false;
                    });
            },
            // 保存
            save(id) {
                //   this.loading = true;
                let a = this.model.editList.find((e) => e.id == id);
                let b = this.list.find((e) => e.id == id);
                b = JSON.parse(JSON.stringify(b));
                b.name = a.name;
                b.type = a.type;
                b.expr = a.expr;
                b.tag = a.tag;
                switch (b.type) {
                    case "number":
                        b.type = 0;
                        break;
                    case "string":
                        b.type = 1;
                        break;
                    case "array":
                        b.type = 2;
                        break;
                    case "object":
                        b.type = 3;
                        break;
                    default:
                        b.type;
                }
                if (!b.tag) {
                    b.tag = null
                }
                if (b.name == "") {
                    this.$message.error("请输入姓名");
                    this.loading = false;
                    return;
                } else if (b.expr == "" || b.expr == "点击输入") {
                    this.$message.error("表达式不得为空");
                    this.loading = false;
                    return;
                } else if (typeof b.type !== "number") {
                    this.$message.error("请输入正确的数据类型");
                    this.loading = false;
                    return;
                } else {
                    if (b.id == "") {
                        delete b.id;
                    }
                    delete b.detail;
                    bdataEdit(b)
                        .then((res) => {
                            if (res.status == 0) {
                                this.$message.success("已保存");
                                this.nameType = false;
                                this.init();
                            }
                            this.loading = false;
                        })
                        .catch((err) => {
                            this.loading = false;
                        });
                }
                this.newlyAddType = false;
                this.inputShow = false;
            },
            // 修改状态
            change(row) {
                this.inputShow = row.id;
                this.tag = row.tag;
                if (!row.tag) {
                    this.tag = '点击输入'
                }
                if (row.expr.length == 0) {
                    let a = this.model.editList.find((e) => e.id == row.id);
                    a.expr = '点击输入'
                }
                this.nameType = false;
            },
            // 预览功能
            previewShow(preview) {
                this.dialogVisible = true;
                this.previewDetail = preview.expr;
            },
            // 打开表达式编辑器
            doExpr(row, index) {
                this.containerShow = true;
                this.exprId = row.id;
                if (this.model.editList[index].expr == "点击输入") {
                    this.editor.setValue("");
                } else {
                    this.editor.setValue(this.model.editList[index].expr);
                }
            },
            // 清空表达式列表
            cleanExprList() {
                this.exprList = [];
                this.exprType = false;
            },
            // 显示表达式
            handleSelectDivid(item) {
                this.loading = true;
                this.divname = item.name;
                this.exprType = true;
                this.exprList = [];
                this.onChangePreviewData(item.id);
            },
            // 显示表达式
            onChangePreviewData(divid) {
                this.tables = [];
                div({
                    id: divid,
                })
                    .then((res) => {
                        if (res.status == 0) {
                            this.tables = res.tables;
                            if (this.tables.length !== 0) {
                                this.list.forEach((item) => {
                                    let detail = this.preview(item.expr);
                                    if (detail !== null) {
                                        this.exprList.push({
                                            id: item.id,
                                            expr: detail.result,
                                            type: detail.type,
                                        });
                                    }
                                });
                            }
                        }
                        this.loading = false;
                    });
            },
            // 已选事件
            revoke(row) {
                this.loading = true;
                row.editType = false;
                this.bdataValue = this.bdataValue.filter((item) => item !== row.id);
                this.addBdata(2);
            },
            // 添加事件
            add(row) {
                this.loading = true;
                row.editType = true;
                this.bdataValue.push(row.id);
                this.addBdata(1);
            },
            // 切换
            goSupport() {
                this.type = !this.type;
            },
            // postBdata
            addBdata(num) {
                postBdata({
                    bdata: this.bdataValue,
                })
                    .then((res) => {
                        if (res.status == 0) {
                            num == 1
                                ? this.$message.success("已选中")
                                : this.$message.success("已取消");
                            this.init();
                        }
                    });
            },
            // 获取单位列表
            getDivsList() {
                getDivs().then((res) => {
                    if (res.status == 0) {
                        this.divs = res.divs.filter((e) => e.type !== 1);
                    }
                });
            },
            init() {
                this.loading = true;
                getBdata().then((res) => {
                    if (res.status == 0) {
                        this.bdataList = res.bdata;
                        this.bdata();
                    }
                }).catch(err => {
                    this.loading = false
                })
            },
            bdata() {
                bdata()
                    .then((res) => {
                        res.bdata.forEach((ele) => {
                            switch (ele.type) {
                                case 0:
                                    ele.type = "number";
                                    break;
                                case 1:
                                    ele.type = "string";
                                    break;
                                case 2:
                                    ele.type = "array";
                                    break;
                                case 3:
                                    ele.type = "object";
                                    break;
                                default:
                                    ele.type;
                            }
                        });
                        this.model.editList = res.bdata.map((e) => {
                            return {
                                id: e.id,
                                type: e.type,
                                expr: e.expr,
                                name: e.name,
                                tag: e.tag,
                            };
                        });
                        this.exprList = [];
                        this.bdataValue = [];
                        //console.log('原始数据', res.bdata)
                        res.bdata.forEach((ele) => {
                            let detail = this.preview(ele.expr);
                            if (detail !== null) {
                                this.exprList.push({
                                    id: ele.id,
                                    expr: detail.result,
                                    type: detail.type,
                                });
                            }
                            this.bdataList.forEach((el) => {
                                if (ele.id == el.id) {
                                    ele.editType = true;
                                    this.bdataValue.push(el.id);
                                }
                            });
                        });
                        this.list = res.bdata;
                        let arr = []
                        this.list.forEach(ele => {
                            arr.push(ele.tag)
                        })
                        this.tagType = Array.from(new Set(arr))
                        this.loading = false;
                    })
                    .catch((err) => {
                        this.loading = false;
                    });
            },
            preview(expr) {
                if (expr == "点击输入") {
                    return null;
                }
                try {
                    let result = eval(this.makeEnvCode(this.tables) + expr);
                    return {
                        type: true,
                        result,
                    };
                } catch (ex) {
                    return {
                        type: false,
                        result: ex,
                    };
                }
            },
            async querySearchDivid(queryString, cb) {
                var restaurants = this.divs;
                var results = queryString
                    ? restaurants.filter(this.createFilterDivid(queryString))
                    : restaurants;
                // 调用 callback 返回建议列表的数据
                cb(results);
            },
            createFilterDivid(queryString) {
                return (restaurant) => {
                    return (
                        restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) !==
                        -1
                    );
                };
            },
            initEditor() {
                this.editor = monaco.editor.create(this.$refs.container, {
                    value: "", //编辑器初始显示文字
                    language: "javascript", //语言支持自行查阅demo
                    selectOnLineNumbers: true, //显示行号
                    glyphMargin: true, //字形边缘
                    // autoIndent: true, //自动布局
                    automaticLayout: true, //自动布局
                    theme: "vs-dark", //官方自带三种主题vs, hc-black, or vs-dark
                });
            },
        },
    };
</script>

<style scoped>
    .bdata {
        width: 90%;
        padding: 30px;
    }

        .bdata .top {
            margin: 20px 0;
            height: 650px;
            overflow: auto;
        }

    .ellipsis {
        word-break: break-all;
        text-overflow: ellipsis;
        overflow: hidden;
        display: -webkit-box;
        -webkit-line-clamp: 4;
        -webkit-box-orient: vertical;
    }

    .bdata .mask {
        position: fixed;
        top: 0;
        left: 0;
        height: 100%;
        width: 100%;
        background: rgba(0, 0, 0, 0.5);
        z-index: 1;
    }

        .bdata .mask .mask-c {
            width: 70%;
            background-color: #fff;
            margin: 0 auto;
            margin-top: 1%;
            overflow: hidden;
        }

            .bdata .mask .mask-c .container {
                height: 85vh;
                width: 90%;
                background-color: #000000;
                margin: 0 auto;
                margin-top: 2%;
            }

    .footer {
        float: right;
        margin: 2% 50px 10px 0;
    }

    .error {
        color: red;
    }

    .el-form-item {
        margin-bottom: 0px;
    }
</style>